import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const trpcSlice = createApi({
  reducerPath: "trpc",
  baseQuery: fetchBaseQuery({
    baseUrl: "/api/trpc",
    prepareHeaders: (headers, { getState }) => {
      const state = getState() as any; // eller RootState om du har den
      const xApiKey: string | null | undefined = state.globalReducer?.xApiKey;

      if (xApiKey) {
        headers.set("x-api-key", xApiKey);
      } else {
        headers.delete("x-api-key"); // valfritt, men tydligt
      }

      return headers;
    },
  }),
  keepUnusedDataFor: 120,
  endpoints: (build) => ({}),
  tagTypes: [
    "TrpcMembers",
    "Issue",
    "Checklist",
    "TrpcMembersByUserRelation",
    "ConnectedIssues",
    "Whoami",
    "UserApikey",
    "IssueTableTemplates",
    "ConnectedTasks",
    "IssueLogs",
    "FormulaGroupIssues",
    "Issues",
    "TrpcNews",
    "NotificationIssueStatuses",
    "Meeting",
    "MeetingSerie",
    "MeetingAgenda",
  ],
});

export const { reducer: trpcReducer } = trpcSlice;
